import React, { useEffect } from 'react';
import { Box, FlexControlledForm,useDebounceState } from '@common-fe/common-fe';

import { PersonalInformationPayload,useStore } from '../stores/usePersonalInformation.store';

import { usePoliticallyExposedNamesFields } from './hooks';

interface Props {
  onDirty?: (isDirty: boolean) => void;
}

const PoliticallyExposedNames: React.FC<Props> = ({ onDirty }) => {
  const fields = usePoliticallyExposedNamesFields();
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<PersonalInformationPayload>>();

  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  return (
    <Box background="canvas" round="container1Round" margin={{ bottom: 'spacing24' }} data-testid="PoliticallyExposedNames-wrapper">
      <FlexControlledForm
        shouldControlValues
        fields={fields}
        testId="politically_exposed_names_form"
        showError={showErrors}
        editMode
        onChangeValues={setValues}
        onDirty={onDirty}
      />
    </Box>
  );
};
export default PoliticallyExposedNames;
